import { render } from "./SlideInPanel.vue?vue&type=template&id=0c9e9cad"
import script from "./SlideInPanel.vue?vue&type=script&lang=js"
export * from "./SlideInPanel.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\softw\\Documents\\Software\\Projects\\CodeRedLabs\\manila-customer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__